<template>
  <span v-if="isInRoute && disabled">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          small
          class="mt-3"
          color="error"
          v-on="on"
        >
          Удалить
        </v-btn>
      </template>
      <span>Звено в маршруте. Для удаления обратитесь к логисту</span>
    </v-tooltip>
  </span>
  <span v-else>
    <v-btn
      small
      class="mt-3"
      color="error"
      :disabled="disabled"
      v-on="$listeners"
    >
      Удалить
    </v-btn>
  </span>
</template>

<script>
export default {
  props: ["isInRoute", "disabled"],
};
</script>
